const BaseComponent = require('base/base-component');

class globalSearch extends BaseComponent {
  constructor () {
    super({
      events: {
        'input .mainkeyword': 'shapeShow',
        'click .icon-Shape': 'emptyInput',
        'keydown .mainkeyword': 'enterSearch',
        'click .Jsearch': 'btnSearch'
      }
    });
  }

  init () {
    this.$input = this.$el.find('.mainkeyword');
    // this.$module = this.$el.find('[name="module"]');
  }

  btnSearch () {
    let keyword = this.$input.val();
    // let m = this.$module.val();
    location.href = `/full/search.html?m=0&k=${encodeURIComponent(keyword)}`;
  }

  emptyInput (e) {
    this.$input.val('');
    $(e.target).hide();
  }

  enterSearch (e) {
    let keyword = this.$input.val();
    // let m = this.$module.val();
    e.keyCode == 13 && (location.href = `/full/search.html?m=0&k=${encodeURIComponent(keyword)}`);
  }

  shapeShow (e) {
    const $ele = $(e.target || e.srcElement);
    if ($ele.val().length > 0) {
      this.$el.find('.icon-Shape').show();
    } else {
      this.$el.find('.icon-Shape').hide();
    }
  }

}
module.exports = globalSearch;
